export default function(instance){
    return{
        Add(payload){
            return instance.post('/Company?NameRu=' + payload.nameRu + '&NameEn=' + payload.nameEn + '&BaseCompanyId=' + payload.baseCompanyId);
        },
    }
}
